import React, {Component} from 'react';
import RaisedButton from 'material-ui/RaisedButton'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import DropZone from '../common/DropZone';
import LocatorResult from '../locator/LocatorResult.js';
import api from '../../api/api';

import './BulkUpload.css';

class BulkUpload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            practiceTypes: null,
            practiceSpecialties: null,
            showDialog: false,
            notFound: null,
            locations: null,
            uploading: false,
            results: null
        }
    }

    onFileChanged = (event) => {
        this.onFileDrop(event.target.files[0]);
    }

    onFileDrop = (file) => {
        var reader = new FileReader();
        this.setState({loading: true});
        reader.onload = (e) => {
            var text = reader.result;
            var lines = text.split(/\n/);

            if (!this.state.practiceTypes) {
                api.getAttributes((attributes) => {
                    let practiceTypes = this.buildAttributeNameKeyPairs(attributes, 5);
                    let practiceSpecialties = this.buildAttributeNameKeyPairs(attributes, 2);
                    this.setState({practiceTypes: practiceTypes, practiceSpecialties: practiceSpecialties});

                    // console.log(practiceTypes);
                    // console.log(practiceSpecialties);

                    this.parseLines(lines, practiceTypes, practiceSpecialties);
                });
            } else {
                this.parseLines(lines, this.state.practiceTypes, this.state.practiceSpecialties);
            }
        }
        reader.readAsText(file, "UTF-8");
    }

    buildAttributeNameKeyPairs = (attributes, index) => {
        let result = {};
        let attribute = attributes[index];
        Object.keys(attribute.options).forEach((key) => {
            let name = attribute.options[key].name;
            result[name] = key;
            result.attributeKey = attribute.key;
        });
        return result;
    }

    parseLines = (lines, practiceTypes, practiceSpecialties) => {
        let typesNotFound = [];
        let specialtiesNotFound = [];
        let results = [];

        lines.forEach((line, index) => {
            let parts = line.split(/\t/);
            if (index > 0) {
                let location = {
                    active: true,
                    attributes: {}
                };

                let keys = ["name", "address1", "address2", "city", "stateAbbr", "postCode", "phoneNumber", "faxNumber", "url"];
                keys.forEach((key, index) => {
                    if (parts[index] && parts[index].trim().length) {
                        location[key] = parts[index];
                    }
                });

                if (!practiceTypes[parts[9]]) {
                    if (!typesNotFound.includes(parts[9])) {
                        typesNotFound.push(parts[9]);
                    }
                } else {
                    let locationAttribute = {
                        choice: [practiceTypes[parts[9]]],
                        name: "Practice Type",
                    }
                    location.attributes["4ce48f84"] = locationAttribute;
                }

                if (parts[10]) {
                    let specialties = parts[10].split(/; ?/);
                    let specialtyChoices = [];
                    specialties.forEach((specialty) => {
                        if (!practiceSpecialties[specialty]) {
                            if (!specialtiesNotFound.includes(specialty)) {
                                specialtiesNotFound.push(specialty);
                            }
                        } else {
                            specialtyChoices.push(practiceSpecialties[specialty]);
                        }
                    });
                    if (specialtyChoices.length) {
                        let locationAttribute = {
                            choice: specialtyChoices,
                            name: "Practice Specialty",
                        }
                        location.attributes["2b7ddb01"] = locationAttribute;
                    }
                }

                if (parts[11] && parts[11].length) {
                    let locationAttribute = {
                        choice: [],
                        name: "Accepts Patients from Outside Doctors"
                    }
                    if (parts[11].match(/yes/i)) {
                        locationAttribute.choice.push("6c25249b");
                    } else {
                        locationAttribute.choice.push("149a4669");
                    }
                    location.attributes["24331fda"] = locationAttribute;
                }

                if (parts[12] && parts[12].length) {
                    let locationAttribute = {
                        choice: [],
                        name: "Facility Type"
                    }
                    if (parts[12].match(/yes/i)) {
                        locationAttribute.choice.push("024a0dd9");
                    } else {
                        locationAttribute.choice.push("cfd0ec05");
                    }
                    location.attributes["04ec22a4"] = locationAttribute;
                }

                results.push(location);
            }
        });

        this.setState({
            loading: false,
            notFound: {
                types: typesNotFound,
                specialties: specialtiesNotFound,
            },
            locations: results
        })

        // console.log(typesNotFound);
        // console.log(specialtiesNotFound);
    }

    closeDialog = () => {
        this.setState({
            showDialog: false,
            results: null,
            notFound: null,
            locations: null,
            uploading: false,
        });
    }

    startUpload = () => {
        if (this.state.locations) {
            this.setState({
                uploading: true,
                results: {
                    currentIndex: 0,
                    failures: [],
                    numSuccesses: 0,
                    bulkUpload: api.createBulkUploadRecord()
                }
            });
            this.geoCodeLocation(0, true);
        }
    }

    stopUpload = () => {
        this.setState({uploading: false});
    }

    geoCodeLocation = (currentIndex, uploading) => {
        if (uploading && currentIndex < this.state.locations.length) {
            // console.log("geocoding: %d", currentIndex);
            let location = this.state.locations[currentIndex];
            let query = location.address1 + " " + location.city + ", " + location.stateAbbr + " " + location.postCode;
            api.geoCodeQuery(query, (lat, lng) => {
                if (lat && lng) {
                    this.setState((prevState) => {
                        let results = prevState.results;
                        results.currentIndex += 1;
                        results.numSuccesses++;
                        location.latitude = lat;
                        location.longitude = lng;
                        location.bulkUploadId = prevState.results.bulkUpload.key;
                        api.createBulkUploadLocation(location);
                        window.setTimeout(this.geoCodeLocation.bind(null, results.currentIndex, prevState.uploading), 100);
                        return {
                            results: results
                        };
                    });
                } else {
                    this.setState((prevState) => {
                        let results = prevState.results;
                        results.failures.push({name: prevState.locations[results.currentIndex].name, address1: prevState.locations[results.currentIndex].address1});
                        results.currentIndex += 1;
                        window.setTimeout(this.geoCodeLocation.bind(null, results.currentIndex, prevState.uploading), 100);
                        return {
                            results: results
                        };
                    })
                }
            });
        } else {
            // console.log("finished: " + currentIndex);
            let bulkUpload = this.state.results.bulkUpload;
            bulkUpload.processed = this.state.results.currentIndex;
            bulkUpload.failures = this.state.results.failures;
            bulkUpload.completed = new Date().toString();
            api.updateBulkUpload(bulkUpload);
            this.setState({uploading: false});
        }
    }

    openDialog = () => {
        this.setState({showDialog: true});
    }

    onChooseFileClick = () => {
        this.refs.fileInput.click();
    }

    getDialogContent() {
        if (!this.state.locations) {
            return (
                <div>
                    <DropZone
                        emptyContent={
                            <div>
                                <div className="drop-zone-title">Drag and Drop</div>
                                <div className="drop-zone-or">or</div>
                                <div>
                                    <RaisedButton
                                        label="Choose File"
                                        buttonStyle={{width: "330px"}}
                                        primary={true}
                                        onTouchTap={this.onChooseFileClick} />
                                </div>
                                <input
                                    ref="fileInput"
                                    type="file"
                                    accept=".tsv"
                                    style={{visibility: "hidden"}}
                                    onChange={this.onFileChanged} />
                            </div>
                        }
                        accepts="tsv"
                        onDrop={this.onFileDrop}
                        uploading={this.state.loading}
                    />
                    <div className="bulk-upload-helper-text">
                        Don&#39;t worry, you&#39;ll have a chance to review the upload before anything is imported.
                    </div>
                    <div className="bulk-upload-actions">
                        <FlatButton label="Cancel" onClick={this.closeDialog} />
                    </div>
                </div>
            )
        } else if (!this.state.results) {
            return (
                <ImportSummary
                    notFound={this.state.notFound}
                    locations={this.state.locations}
                    closeDialog={this.closeDialog}
                    startUpload={this.startUpload} />
            )
        } else{
            return (
                <ImportResults
                    closeDialog={this.closeDialog}
                    locations={this.state.locations}
                    results={this.state.results}
                    uploading={this.state.uploading}
                    stopUpload={this.stopUpload} />
            )
        }
    }

    render() {
        return (
            <div style={{margin: "15px 0 0 0", textAlign: "right"}}>
                <RaisedButton
                    label="Bulk upload"
                    onClick={this.openDialog}
                    primary={true}
                    labelStyle={{color: "#ffffff"}}/>
                <Dialog
                    style={{zIndex: 5000}}
                    open={this.state.showDialog}
                    onRequestClose={this.closeDialog}
                    modal={true}
                    autoScrollBodyContent={true}>

                    <div className="bulk-upload-title">Bulk Upload</div>
                    {this.getDialogContent()}

                </Dialog>
            </div>
        )
    }
}

class ImportSummary extends Component {
    render() {
        return (
            <div>
                <div className="bulk-upload-section-title">
                    Practice Specialties Not Found
                </div>
                <div className="bulk-upload-label">
                    {this.props.notFound ? this.props.notFound.specialties.join(", ") : "N/A"}
                </div>
                <div className="bulk-upload-section-title">
                    Practice Types Not Found
                </div>
                <div className="bulk-upload-label">
                    {this.props.notFound ? this.props.notFound.types.join(", ") : "N/A"}
                </div>
                <div className="bulk-upload-section-title">
                    Num locations: <span className="bulk-upload-label">{this.props.locations ? this.props.locations.length : 0}</span>
                </div>
                <div className="bulk-upload-section-title">
                    Preview
                </div>
                <div>
                    {this.props.locations && this.props.locations.length ?
                        <div>
                            <LocatorResult
                                result={this.props.locations[0]}
                                imageSize={118} />
                        </div>
                        :
                        null
                    }
                </div>
                <div className="bulk-upload-actions">
                    <FlatButton label="Cancel" onClick={this.props.closeDialog} style={{marginRight: "25px"}} />
                    <RaisedButton primary={true} labelStyle={{color: "#ffffff"}} label="Looks good, start import" onClick={this.props.startUpload} />
                </div>
            </div>
        )
    }
}

class ImportResults extends Component {
    render() {
        return (
            <div>
                <div className="bulk-upload-section-title">
                    Status: <span className="bulk-upload-label">{this.props.uploading ? "Processing" : "Complete"}</span>
                </div>
                <div className="bulk-upload-section-title">
                    Currently Processing: <span className="bulk-upload-label">{this.props.results.currentIndex + 1}</span>
                </div>
                <div className="bulk-upload-section-title">
                    Remaining: <span className="bulk-upload-label">{this.props.locations.length - (this.props.results.currentIndex + 1)}</span>
                </div>
                <div className="bulk-upload-section-title">
                    Failures: <span className="bulk-upload-label">{this.props.results.failures.length}</span>
                </div>
                <div>
                    {this.props.results.failures.length ?
                        this.props.results.failures.map((failure, index) => {
                            return (
                                <div className="bulk-upload-result-failure bulk-upload-label" key={"failure-" + index}>
                                    <div>
                                        {failure.name}
                                    </div>
                                    <div>
                                        {failure.address1} {failure.city}, {failure.stateAbbr} {failure.postCode}
                                    </div>
                                </div>
                            )
                        })
                        :
                        "N/A"
                    }
                </div>
                <div className="bulk-upload-actions">
                    {this.props.uploading ?
                        <RaisedButton backgroundColor="#ff0000" labelStyle={{color: "#ffffff"}} label="Stop" onClick={this.props.stopUpload} />
                        :
                        <RaisedButton primary={true} labelStyle={{color: "#ffffff"}} label="Finish" onClick={this.props.closeDialog} />
                    }
                </div>
            </div>
        )
    }
}

export default BulkUpload;



// WEBPACK FOOTER //
// ./src/components/admin-location-manager/BulkUpload.js